<template>
  <div class="menu-header__section" :style="{ backgroundImage: `url(${$CDN}${backgroundImage})` }">
    <content-container>
      <div class="menu-header__rest-logo-wrapper">
        <div class="menu-header__rest-logo">
          <img class="img-responsive" :src="$CDN + restLogo" />
        </div>
      </div>
    </content-container>
  </div>
</template>

<script>
import ContentContainer from './ContentContainer.vue'

export default {
  name: 'MenuHero',
  components: {
    ContentContainer,
  },
  props: {
    restLogo: {
      type: String,
    },
    backgroundImage: {
      type: String,
    },
  },
}
</script>

<style scoped lang="scss">
.menu-header__section {
  background-size: cover;
  padding: 100px 0;
  background-position: center;
  position: relative;
}

.menu-header__rest-logo-wrapper {
  width: 100px;
  height: 100px;
  position: absolute;
  bottom: 0;
}

.menu-header__rest-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  box-shadow: 1px 1px 5px 0 rgba(171, 168, 168, 0.5);
  background-color: #23212194;
  border-radius: 5px;
}

.img-responsive {
  display: block;
  width: 100%;
  height: auto;
}
</style>
